import { render, staticRenderFns } from "./add-research-site-document.vue?vue&type=template&id=ae90c83e&scoped=true&"
import script from "./add-research-site-document.vue?vue&type=script&lang=js&"
export * from "./add-research-site-document.vue?vue&type=script&lang=js&"
import style0 from "../../../public/static/fonts.scss?vue&type=style&index=0&id=ae90c83e&scoped=true&lang=scss&"
import style1 from "./add-research-site-document.vue?vue&type=style&index=1&id=ae90c83e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae90c83e",
  null
  
)

component.options.__file = "add-research-site-document.vue"
export default component.exports